<template>
  <UIDrawer
    :title
    :is-open
    :z-index
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <TagForm :instance="modal.entity" @close="handleClose" />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { TagClass } from '..'
import { ModalClass } from '@types'

import { TAG_MODAL_TITLE, TAG_MODAL_TITLE_NEW } from './utils/const'

import { UIDrawer } from '@ui/modals'
import TagForm from './TagForm.vue'

type Props = {
  modal: ModalClass<TagClass>
}

const props = defineProps<Props>()

const title = computed(() =>
  props.modal.entity.isNew ? TAG_MODAL_TITLE_NEW : TAG_MODAL_TITLE,
)

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleMinimize = () => {
  props.modal.hide()
}

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
